import { useTranslation } from 'react-i18next'
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui'

interface ConfirmReplaceModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}

export function ConfirmReplaceModal({
  isOpen,
  onClose,
  onConfirm,
}: ConfirmReplaceModalProps) {
  const { t } = useTranslation()

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className='max-w-md' showCloseButton={false}>
        <DialogHeader>
          <DialogTitle className='text-lg font-semibold text-center'>
            {t('toolManagement.replaceFileTitle')}
          </DialogTitle>
        </DialogHeader>
        <div className='py-4'>
          <DialogDescription
            className='text-sm text-gray-600 text-center'
            dangerouslySetInnerHTML={{
              __html: t('toolManagement.replaceFileMessage'),
            }}
          />
        </div>
        <div className='flex gap-3 pt-4'>
          <Button
            type='button'
            variant='outline'
            onClick={onClose}
            className='flex-1'
          >
            {t('common.cancel')}
          </Button>
          <Button
            type='button'
            className='bg-red-600 hover:bg-red-700 flex-1'
            onClick={onConfirm}
          >
            {t('common.confirm')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
